// BBN Nordics egna foton — hämtade från bbnnordic.se och hostade på CDN.
// Alla AI-genererade bilder har ersatts med riktiga BBN-foton.
import bbnPrestigeHero from "@/assets/bbn/bbn-prestige-hero.webp.asset.json";
import bbnPrestigeProduct from "@/assets/bbn/bbn-prestige-product.webp.asset.json";
import bbnPrestigePrivate from "@/assets/bbn/bbn-prestige-private.webp.asset.json";
import bbnBuildingSun from "@/assets/bbn/bbn-building-sun.webp.asset.json";
import bbnInstallationRef from "@/assets/bbn/bbn-installation-reference.webp.asset.json";
import bbnInstallation1 from "@/assets/bbn/bbn-installation-1.webp.asset.json";
import bbnInstallation2 from "@/assets/bbn/bbn-installation-2.webp.asset.json";
import bbnInstallation3 from "@/assets/bbn/bbn-installation-3.webp.asset.json";
import bbnInstallation4 from "@/assets/bbn/bbn-installation-4.webp.asset.json";
import bbnInstallation5 from "@/assets/bbn/bbn-installation-5.webp.asset.json";
import bbnInstallerPortrait from "@/assets/bbn/bbn-installer-portrait.jpeg.asset.json";
import bbnShopSecurity from "@/assets/bbn/bbn-shop-security.webp.asset.json";
import bbnSakerhetsfilmKontorHero from "@/assets/bbn/bbn-sakerhetsfilm-kontor-hero.webp.asset.json";

import bbnSolfilmWindow from "@/assets/bbn/bbn-solfilm-window.jpg.asset.json";

import bbnDekorOffice from "@/assets/bbn/bbn-dekorfilm-office.webp.asset.json";
import bbnKontorRullegardiner from "@/assets/bbn/bbn-kontor-rullegardiner.webp.asset.json";
// Referensbilder (svenska/danska projekt)
import refSolfilm1 from "@/assets/bbn/bbn-referens-solfilm-1.webp.asset.json";
import refSolfilm2 from "@/assets/bbn/bbn-referens-solfilm-2.webp.asset.json";
import refSolfilm3 from "@/assets/bbn/bbn-referens-solfilm-3.webp.asset.json";
import refSolfilm4 from "@/assets/bbn/bbn-referens-solfilm-4.webp.asset.json";
import refSolfilm5 from "@/assets/bbn/bbn-referens-solfilm-5.webp.asset.json";
import refSolfilm6 from "@/assets/bbn/bbn-referens-solfilm-6.webp.asset.json";
import refSolfilm7 from "@/assets/bbn/bbn-referens-solfilm-7.webp.asset.json";
import refDekor1 from "@/assets/bbn/bbn-referens-dekorfilm-1.webp.asset.json";
import refDekor2 from "@/assets/bbn/bbn-referens-dekorfilm-2.webp.asset.json";
import refDekor3 from "@/assets/bbn/bbn-referens-dekorfilm-3.webp.asset.json";
import refDekor4 from "@/assets/bbn/bbn-referens-dekorfilm-4.webp.asset.json";
import refDekor5 from "@/assets/bbn/bbn-dekor-variation-1.webp.asset.json";
import refDekor6 from "@/assets/bbn/bbn-dekor-variation-2.webp.asset.json";
import refDekor7 from "@/assets/bbn/bbn-dekor-variation-3.webp.asset.json";
import refDekor8 from "@/assets/bbn/bbn-dekor-variation-4.webp.asset.json";

/**
 * Bakåtkompatibla alias — pekar nu enbart på BBN:s egna foton.
 * Inga AI-bilder kvar.
 */
export const IMAGES = {
  hero: bbnPrestigeHero.url,
  solfilm: bbnPrestigeHero.url,
  sakerhetsfilm: bbnSakerhetsfilmKontorHero.url,
  dekorfolie: refDekor1.url,
  installer: bbnInstallerPortrait.url,
  solfilmHero: bbnBuildingSun.url,
  sakerhetsfilmHero: bbnShopSecurity.url,
  dekorfolieHero: bbnDekorOffice.url,
} as const;

/**
 * BBN Nordics egna projektbilder, hostade på Lovable CDN.
 */
export const BBN_PHOTOS = {
  prestigeHero: bbnPrestigeHero.url,
  prestigeProduct: bbnPrestigeProduct.url,
  prestigePrivate: bbnPrestigePrivate.url,
  buildingSun: bbnBuildingSun.url,
  installationReference: bbnInstallationRef.url,
  installation1: bbnInstallation1.url,
  installation2: bbnInstallation2.url,
  installation3: bbnInstallation3.url,
  installation4: bbnInstallation4.url,
  installation5: bbnInstallation5.url,
  installerPortrait: bbnInstallerPortrait.url,
  burglaryProtection: bbnShopSecurity.url,
  shopSecurity: bbnShopSecurity.url,
  sakerhetsfilmKontorHero: bbnSakerhetsfilmKontorHero.url,
  solfilmWindow: bbnSolfilmWindow.url,
  dekorGlass: refDekor1.url,
  dekorOffice: bbnDekorOffice.url,
  solfilmBrfHero: refSolfilm4.url,
  kontorRullegardiner: bbnKontorRullegardiner.url,
} as const;

/** Referensbilder från utförda projekt (svenska + danska systerbolaget). */
export const BBN_REFERENCE_SOLFILM = [
  refSolfilm1.url,
  refSolfilm2.url,
  refSolfilm3.url,
  refSolfilm4.url,
  refSolfilm5.url,
  refSolfilm6.url,
  refSolfilm7.url,
] as const;

export const BBN_REFERENCE_DEKOR = [
  refDekor1.url,
  refDekor2.url,
  refDekor3.url,
  refDekor4.url,
  refDekor5.url,
  refDekor6.url,
  refDekor7.url,
  refDekor8.url,
] as const;

/** Riktiga BBN-foton lämpliga för säkerhetsfilm-sidor — cyklas för variation. */
export const BBN_SECURITY = [
  bbnSakerhetsfilmKontorHero.url,
  bbnShopSecurity.url,
  bbnInstallationRef.url,
  bbnInstallation1.url,
  bbnInstallation2.url,
  bbnInstallation3.url,
  bbnInstallation4.url,
  bbnInstallation5.url,
  bbnBuildingSun.url,
] as const;
